<template>
	<div class="list-container">
		<div class="floor-header">
			<div class="title">Våningar</div>
			<button class="button is-info" @click="onAdd" v-if="$isAllowedTo('floors_edit')">
				<span class="icon is-white"><i class="fas fa-plus"/></span
				><span>Ny våning</span>
			</button>
		</div>
		<div class="panel-list-header">
			<div class="panel-header-item">Namn</div>
			<div class="panel-filler" v-if="$isAllowedTo('floors_edit')" />
		</div>
		<div
			class="panel-list"
			v-for="floor in floors"
			:key="floor.id"
			@click="navigate(floor.id)"
		>
			<div class="panel-list-item">{{ floor.name }}</div>
			<div class="list-button" @click.stop="onEdit(floor)">
				<i class="fas fa-edit" v-if="$isAllowedTo('floors_edit')"></i>
			</div>
			<div v-if="$isAllowedTo('floors_edit')" class="list-button" @click.stop="onDelete(floor)">
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list" v-if="floors.length == 0">
			<p class="panel-list-item">Inga resultat</p>
		</div>
		<Pagination
			v-if="floors.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},
	props: {
		floors: Array
	},
	computed: {
		...mapGetters('floorStore', ['pagination'])
	},
	methods: {
		...mapActions('floorStore', ['setCurrentPage', 'setPageSize']),
		onDelete(floor) {
			this.$emit('delete', floor);
		},
		onEdit(floor) {
			this.$emit('edit', floor);
		},
		onAdd() {
			this.$emit('add', this.building);
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		},
		navigate(floorId) {
			if (!this.$isAllowedTo('floors_edit')) return;
			
			this.$emit('navigate', floorId);
		}
	}
};
</script>

<style lang="scss" scoped>
.floor-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  .button {
    margin-bottom: 0.5rem;
    border-radius: 2px;
  }
}
</style>
